import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { moduleSettings } from "../../stores/module-settings.store";
import { InformationText } from "../information-text/information-text";
import { useLocation } from "react-router-dom";

const Message = () => {
  const { i18n } = useTranslation();
  useLocation();
  const waitingInfoMessage = moduleSettings.waitingMessage(i18n.language);

  return (
    <>
      {waitingInfoMessage && (
        <InformationText text={waitingInfoMessage} status="waiting" />
      )}
    </>
  );
};
export const WaitingMessage = memo(Message);
